/* CrispyCards PDP V10 – Card Burst startet am jeweils geklickten Kaufbutton. */
(()=>{'use strict';
const ROOT='.product-section[data-cc-product-redesign="v7"]';
const CARD_URL='https://cdn.shopify.com/s/files/1/0950/2733/1402/files/CrispyCards_Karte_1.webp?v=1793706831';
const reduced=()=>window.matchMedia('(prefers-reduced-motion: reduce)').matches;
function init(root){
 if(root.dataset.ccV7Ready==='1')return;
 const bar=root.querySelector('[data-cc-quickbuy]');
 const add=root.querySelector('.product-single__meta button[name="add"],.product-single__meta .add-to-cart');
 if(!bar||!add)return;
 root.dataset.ccV7Ready='1';
 // Portaling only our own fixed bar, never moving Shopify's actual form.
 document.body.appendChild(bar);
 const action=bar.querySelector('[data-cc-quickbuy-action]');
 const price=root.querySelector('[data-product-price]');
 const barPrice=bar.querySelector('[data-cc-quickbuy-price]');
 const variant=bar.querySelector('[data-cc-quickbuy-variant]');
 let raf=0, lastRain=0;
 let quickBuyOrigin=null; // Synchroner Ursprung für den weitergeleiteten Kaufklick
 const overlays=()=>!!document.querySelector('.pswp--open,#CartDrawer.drawer--is-open,.drawer--is-open,dialog[open]') || document.documentElement.classList.contains('js-drawer-open-right') || document.body.classList.contains('cc-search-open');
 function update(){
   raf=0; if(!root.isConnected){bar.remove();return}
   const header=Number.parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--cc-visible-header-height'))||0;
   const y=add.getBoundingClientRect().bottom;
   const show=y < Math.max(header+12,100) && window.scrollY>100 && !overlays();
   bar.classList.toggle('cc-quickbuy--visible',show);
   bar.setAttribute('aria-hidden',String(!show));bar.inert=!show;
   if(barPrice&&price)barPrice.textContent=price.textContent.trim();
   let labels=[...root.querySelectorAll('.variant-input-wrap input[type="radio"]:checked')].map(input=>{
      const label=input.id ? root.querySelector('label[for="'+CSS.escape(input.id)+'"]') : null;
      return (label?.textContent||input.value).trim();
   });
   if(!labels.length) root.querySelectorAll('.variant-wrapper select').forEach(el=>labels.push(el.selectedOptions?.[0]?.textContent?.trim()||el.value));
   if(variant){variant.textContent=labels.filter(Boolean).join(' · ');variant.hidden=!variant.textContent;}
   if(action){action.disabled=add.disabled||add.getAttribute('aria-disabled')==='true';}
 }
 const schedule=()=>{if(!raf)raf=requestAnimationFrame(update)};
 function scrollToBuy(){const header=Number.parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--cc-visible-header-height'))||0;window.scrollTo({top:Math.max(0,window.scrollY+add.getBoundingClientRect().top-header-100),behavior:reduced()?'instant':'smooth'});}
 action?.addEventListener('click',()=>{
   if(action.disabled)return;
   // Custom Mystery configurators can require external mandatory inputs and validations.
   // Never bypass those custom controls from a second CTA.
   if(action.dataset.ccSpecialOptions==='true'){scrollToBuy();return;}
   // Die native Impulse-Kaufaktion bleibt erhalten. Der Kartenregen soll jedoch
   // aus dem tatsächlich angeklickten Quick-Buy-Button starten.
   quickBuyOrigin=action;
   try {
     add.click();
   } finally {
     quickBuyOrigin=null;
   }
 });
 // The asset is decoded before a click, so cards do not appear halfway through a burst.
 const cardAsset=new Image();
 cardAsset.src=CARD_URL;
 if(cardAsset.decode)cardAsset.decode().catch(()=>{});
 let activeBurst=null;
 function rain(origin){
   if(reduced() || !cardAsset.complete || !cardAsset.naturalWidth)return;
   const now=performance.now();
   if(now-lastRain<900)return;
   const rect=origin.getBoundingClientRect();
   if(rect.width<1||rect.height<1)return;
   lastRain=now;
   // One continuous physics-based path: upward velocity + gravity.
   // All cards are created in one DOM batch and drawn in the same animation frame.
   if(activeBurst){cancelAnimationFrame(activeBurst.raf);activeBurst.cards.forEach(c=>c.node.remove());activeBurst=null;}
   const mobile=window.innerWidth<=768;
   const count=mobile?9:14;
   const centerX=rect.left+rect.width*.5;
   const centerY=rect.top+rect.height*.45;
   const width=window.innerWidth;
   const height=window.innerHeight;
   const fragment=document.createDocumentFragment();
   const cards=[];
   for(let i=0;i<count;i++){
     const node=document.createElement('img');
     node.className='cc-rain-card';
     node.src=CARD_URL;
     node.alt='';node.draggable=false;
     node.setAttribute('aria-hidden','true');
     node.style.left=`${centerX}px`;
     node.style.top=`${centerY}px`;
     // Stable fan of trajectories, varied slightly so the cards look physical.
     const lateral=(i-(count-1)/2)/((count-1)/2);
     const vx=lateral*(mobile?260:550)+(Math.random()-.5)*65;
     const vy=-(mobile?780:1000)-Math.random()*(mobile?160:185);
     const gravity=mobile?1740:1900;
     const rotation=(Math.random()-.5)*55;
     const spin=(Math.random()-.5)*380;
     const duration=Math.min(2.1,Math.max(1.4,(-vy+Math.sqrt(vy*vy+2*gravity*(height-centerY+110)))/gravity));
     fragment.appendChild(node);
     cards.push({node,vx,vy,gravity,rotation,spin,duration});
   }
   document.body.appendChild(fragment);
   // Prevent cards from flashing at full size before the first paint.
   cards.forEach(({node})=>{node.style.opacity='0';node.style.transform='translate3d(-50%,-50%,0) scale(.35)';});
   const burst={cards,raf:0};activeBurst=burst;
   const start=performance.now();
   const animate=(timestamp)=>{
     const t=Math.max(0,(timestamp-start)/1000);
     let running=false;
     for(const card of cards){
       const {node,vx,vy,gravity,rotation,spin,duration}=card;
       if(t>=duration){node.remove();continue;}
       running=true;
       const x=vx*t;
       const y=vy*t+.5*gravity*t*t;
       const pop=Math.min(1,t/.18);
       const scale=.35+.65*(1-Math.pow(1-pop,3));
       const fade=Math.min(1,(duration-t)/.24);
       node.style.opacity=String(Math.min(pop*5,fade));
       node.style.transform=`translate3d(calc(-50% + ${x.toFixed(2)}px),calc(-50% + ${y.toFixed(2)}px),0) rotate(${(rotation+spin*t).toFixed(2)}deg) scale(${scale.toFixed(3)})`;
     }
     if(running)burst.raf=requestAnimationFrame(animate);
     else{cards.forEach(c=>c.node.remove());if(activeBurst===burst)activeBurst=null;}
   };
   burst.raf=requestAnimationFrame(animate);
 }
 // Visual response on valid user buy attempt. It is not a success notification.
 add.addEventListener('click',()=>{
   const form=add.closest('form');
   if(add.disabled || add.getAttribute('aria-disabled')==='true' || form && !form.checkValidity())return;
   rain(quickBuyOrigin && quickBuyOrigin.isConnected ? quickBuyOrigin : add);
 },{passive:true});
 window.addEventListener('scroll',schedule,{passive:true});window.addEventListener('resize',schedule,{passive:true});
 root.addEventListener('change',schedule);root.addEventListener('variant:change',schedule);
 const observer=new MutationObserver(schedule);
 observer.observe(root,{attributes:true,subtree:true,childList:true,characterData:true,attributeFilter:['class','disabled','aria-disabled','checked']});
 // Update bar when drawer/search changes, without continuously observing the entire DOM.
 const external=new MutationObserver(schedule);
 external.observe(document.documentElement,{attributes:true,attributeFilter:['class']});
 external.observe(document.body,{attributes:true,attributeFilter:['class']});
 update();
}
function boot(scope=document){if(scope.matches?.(ROOT))init(scope);scope.querySelectorAll?.(ROOT).forEach(init)}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>boot(),{once:true});else boot();
document.addEventListener('shopify:section:load',e=>boot(e.target));
})();
